import {
  Component,
  OnInit,
  HostListener,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { Chart } from 'angular-highcharts';
import { environment } from '../../../../../environments/environment';
import { RecommendationService } from './../recommendation.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as Highcharts from 'highcharts';
import * as _ from 'underscore';
import { ResidentialService } from '../../residential.service';
Highcharts.setOptions({ lang: { thousandsSep: ',' } });
import * as $ from 'jquery';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-single-product',
  templateUrl: './single-product.component.html',
  styleUrls: ['./single-product.component.css'],
})
export class SingleProductComponent implements OnInit, AfterViewInit {
  name;
  Math: any;
  discount = 0;
  url = environment.api_url;
  recommendationObj;
  recommendProduct;
  chart;
  accountId;
  avgMthlyUsage;
  averagePrice;
  avgbill;
  showDetal = true;
  bodyTagScroll;
  Highcharts = Highcharts;
  productListOptions;
  highChartsOptions;
  updateValue = false; // optional boolean
  updateProductChart = false;
  oldValue;
  newValue;
  visibleGraph;
  residentialResponses;
  recommendations;
  fullText = false;
  partialText = true;
  modalRef: BsModalRef;
  @ViewChild('newEnergyRates', { static: true }) newEnergyRates: ElementRef;

  constructor(
    private recommendationService: RecommendationService,
    private router: Router,
    private residentialService: ResidentialService,
    private modalService: BsModalService,
    private _renderer2: Renderer2
  ) {}

  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // To set the chart width based on the sceen resolution
    if (window.screen.availWidth < 500) {
      this.highChartsOptions.plotOptions.series.pointWidth = 22;
      this.updateValue = true;
    } else {
      this.highChartsOptions.plotOptions.series.pointWidth = 35;
      this.updateValue = true;
    }
  }

  // To handle the page close or reload event - After questionnarie
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler($event) {
    $event.returnValue = false;
    const questionObj = {
      questionStatus: 'Completed',
      questionStep: this.residentialService.currentId,
      type: this.residentialService.service,
      percentage: 100,
      enrollmentState: 'Quitted',
    };
    sessionStorage.setItem('questionStatusObj', JSON.stringify(questionObj));
    setTimeout(() => {
      return this.residentialService.quitFlow();
    }, 50);
  }

  ngOnInit() {
    this.loadScript();
    this.accountId = this.recommendationService.hg_accountId;
    const name = this.recommendationService.userName
      ? this.recommendationService.userName
      : '';
    this.name = this.titleCase(name);
    this.getEnergyProvidersRates();
  }

  assignModifiedEnergyProviderRates() {
    const questionObj = !_.isEmpty(
      this.residentialService.questionnaireStatusObj
    )
      ? this.residentialService.questionnaireStatusObj
      : JSON.parse(sessionStorage.getItem('questionStatusObj'));

    const questionnarieObj = !_.isEmpty(
      this.residentialService.userResponse.userResponses
    )
      ? this.residentialService.userResponse
      : JSON.parse(sessionStorage.getItem('userResponse'));
    const user = {
      esiid: null,
      questionStatusObj: questionObj,
      questionnarieObj: questionnarieObj,
    };
    this.residentialService.getRecommendations(user).subscribe((res: any) => {
      const result = res;
      this.recommendationService.recommendationObj =
        result['recommendedProduct'];
      sessionStorage.setItem(
        'recommendedProducts',
        JSON.stringify(result['recommendedProduct'])
      );
      this.openNewEnergyRatesModal(this.newEnergyRates);
    });
  }

  getEnergyProvidersRates() {
    if (this.recommendationService.recommendationObj) {
      this.recommendationObj = this.recommendationService.recommendationObj;
    } else {
      const recommendObj = sessionStorage.getItem('recommendedProducts');
      this.recommendationObj = JSON.parse(recommendObj);
      this.recommendationService.recommendationObj = this.recommendationObj;
    }
    this.name = this.recommendationService.userName
      ? this.recommendationService.userName
      : '';
      try{
        if (_.isEmpty(this.name)) {
          this.name = localStorage.getItem('userName');
          if (
            this.name === undefined ||
            this.name === 'undefined' ||
            this.name === '' ||
            this.name === null
          ) {
            this.name =
              JSON.parse(sessionStorage.getItem('userObj')).fName +
              ' ' +
              JSON.parse(sessionStorage.getItem('userObj')).lName;
          }
          this.name = this.titleCase(this.name);
        }
      }catch{}

    
    if (!_.isEmpty(sessionStorage.getItem('userResponse'))) {
      this.residentialResponses = JSON.parse(
        sessionStorage.getItem('userResponse')
      );
    } else {
      this.residentialResponses = this.residentialService.userResponse;
    }
    var term;
    if(this.residentialResponses.userResponses != null && this.residentialResponses.userResponses.length != 0)
    {
      const TermValue = _.findWhere(this.residentialResponses.userResponses, {
      res_question_id: '0026',
    });
    term = TermValue.fieldValue.split(' ')[0];

    }else
    {
      term == "Compare";
    }
    
    this.recommendations = [];
    this.recommendationObj.res_products_recommendations.map((row, i) => {
      if (row.terms.toString() === term) {
        this.recommendations.push(row);
      } else if (term === 'Compare') {
        this.recommendations.push(row);
      }
    });
    if (this.recommendations.length > 0) {
      this.recommendProduct = this.recommendations[0];
    } else {
      this.recommendProduct =
        this.recommendationObj.res_products_recommendations[0];
    }
    this.recommendationService.signupProduct = this.recommendProduct;
    this.discount =
      this.recommendationService.signupProduct.new_tier.discount_percent;
    this.avgMthlyUsage = Math.round(
      this.recommendProduct.new_tier.ave_monthly_usage
    );
    this.averagePrice = (
      Number(this.recommendProduct.new_tier.ave_price_per_KWH) * 100
    ).toFixed(1);
    this.avgbill = Math.round(this.recommendProduct.new_tier.ave_monthly_bill);
    this.oldValue = this.recommendationObj.current_usage.map(function (
      value,
      key
    ) {
      return {
        point: value.month,
        color: 'rgba(206,206,206,0.5)',
        y: Number(value.avg_energy_charge_per_KWH) * Number(value.usage),
        avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
        usage: Number(value.usage),
      };
    });

    const self = this;
    this.newValue = this.recommendationService.signupProduct.monthly_usage.map(
      function (value, key) {
        return {
          point: value.month,
          color: '#ffc214',
          y: value.avg_energy_charge_per_KWH,
          avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
          energy_charge_per_month: value.total_energy_charge_per_month
            ? value.total_energy_charge_per_month
            : 0,
        };
      }
    );

    // To calculate the  y value as => usage * price/kWh
    for (let i = 0; i < this.oldValue.length; i++) {
      for (let j = 0; j < this.newValue.length; j++) {
        if (this.oldValue[i].point === this.newValue[j].point) {
          this.newValue[j].y = Math.round(
            Number(this.newValue[j].y) * Number(this.oldValue[i].usage)
          );
        }
      }
    }
    this.highChartsOptions = {
      chart: {
        renderTo: 'container',
        type: 'column',
        marginTop: 60,
      },
      xAxis: {
        categories: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        labels: {
          formatter: function (event) {
            // To show the total_energy_charge_per_month below month label in x-axis
            const series2Val = !_.isEmpty(self.visibleGraph)
              ? self.visibleGraph
              : self.highChartsOptions.series[1]
              ? self.highChartsOptions.series[1]
              : self.highChartsOptions.series[0];
            return (
              event.value +
              '<br>' +
              '$' +
              (!_.isEmpty(series2Val)
                ? Math.round(series2Val.data[event.pos].energy_charge_per_month)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
                  '<br>' +
                  (self.highChartsOptions.series[1] != undefined
                    ? (
                        self.highChartsOptions.series[1].data[event.pos]
                          .avg_energy_charge_per_KWH * 100
                      ).toFixed(1) + '¢'
                    : (
                        self.highChartsOptions.series[0].data[event.pos]
                          .avg_energy_charge_per_KWH * 100
                      ).toFixed(1) + '¢')
                : Math.round(
                    self.highChartsOptions.series[0].data[event.pos]
                      .energy_charge_per_month
                  )
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            );
          },
          style: {
            'font-family': 'Calibre',
            'font-size': '13px',
          },
          autoRotation: false,
        },
      },
      yAxis: {
        title: false,
        labels: {
          overflow: 'justify',
          enabled: false,
        },
        gridLineWidth: 0,
      },
      plotOptions: {
        series: {
          // colorByPoint: true,
          cursor: 'pointer',
          point: {
            events: {
              click: function (event) {
                // To handle the bar click event
              },
            },
          },
          pointWidth: 35,
          events: {
            legendItemClick: function (e) {
              const visibility = this.visible ? 'visible' : 'hidden';
              if (_.isEmpty(self.highChartsOptions.series[1])) {
                // new service -> so restrict the click action
                e.preventDefault();
              } else {
                const chart = this.chart;
                const index = this.index;
                let atleastOneVisible = false;
                // assign the visible graph to change the x-axis label on legend click
                $.each(chart.series, function (i, serie) {
                  if (serie.visible && serie.index !== index) {
                    atleastOneVisible = true;
                    self.visibleGraph =
                      self.highChartsOptions.series[serie.index];
                  }
                });
                // if both are visible then choose the new value
                if (
                  atleastOneVisible &&
                  ((chart.series[0].visible === false &&
                    chart.series[1].visible === true) ||
                    (chart.series[1].visible === false &&
                      chart.series[0].visible === true))
                ) {
                  self.visibleGraph = self.highChartsOptions.series[1];
                }
                // to show atleast one legend
                if (!atleastOneVisible) {
                  e.preventDefault();
                } else {
                  self.updateValue = true;
                }
              }
            },
          },
        },
        column: {
          pointWidth: 20,
          groupPadding: 0.5,
        },
      },
      tooltip: {
        style: {
          pointerEvents: 'all',
        },
        useHTML: true,
        formatter: function (event) {
          // To show the tooltip with current usage value
          let tooltipHTML = this.x;
          const series2Val = self.highChartsOptions.series[1];
          if (!_.isEmpty(series2Val)) {
            tooltipHTML =
              '<div class="chart_tool_tip">' +
              this.x +
              '<span class="d-block">' +
              // (this.y).toFixed(1)
              Math.round(
                self.highChartsOptions.series[0].data[this.point.index].usage
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
              '</span>' +
              '</div>';
            return tooltipHTML;
          } else {
            tooltipHTML =
              '<div class="chart_tool_tip">' +
              this.x +
              '<span class="d-block">' +
              // (this.y).toFixed(1)
              Math.round(self.oldValue[this.point.index].usage)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
              '</span>' +
              '</div>';
            return tooltipHTML;
          }
        },
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        verticalAlign: 'top',
        floating: true,
        x: 0,
        y: 0,
        backgroundColor: '#FFFFFF',
        shadow: false,
        useHTML: true,
        margin: 100,
        itemDistance: 50,
        itemMarginTop: 5,
        itemMarginBottom: 5,
        itemStyle: {
          color: '#000000',
          fontWeight: 'normal',
          fontSize: '14px',
          fontFamily: 'Calibre',
        },
        symbolRadius: 0,
        labelFormatter: function (event) {
          return this.name;
        },
      },
      series: [
        {
          name:
            '<span class="d-block"> Recommended - ' +
            '<span style="font-family: Calibre-SemiBold">' +
            this.recommendProduct.energy_provider +
            ' ' +
            this.recommendProduct.terms +
            ' Months' +
            '</span>',
          data: this.newValue,
          color: '#ffc214',
          useHTML: true,
        },
      ],
    };

    // To check 'New Service' and 'Switching providers'
    if (this.recommendationObj.service_type !== 'Switching Providers') {
      this.highChartsOptions.series = [
        {
          name:
            '<span class="d-block"> Recommended - ' +
            '<span style="font-family: Calibre-SemiBold">' +
            this.recommendProduct.energy_provider +
            ' ' +
            this.recommendProduct.terms +
            ' Months' +
            '</span>',
          data: this.newValue,
          color: '#ffc214',
          useHTML: true,
        },
      ];
      // to disable the legend hover
      this.highChartsOptions.legend.itemStyle = {
        color: '#000000',
        fontWeight: 'normal',
        fontSize: '14px',
        fontFamily: 'Calibre',
        cursor: 'default',
      };
      this.updateValue = true;
    }

    // To set the chart width based on the sceen resolution
    if (window.screen.availWidth < 500) {
      this.highChartsOptions.plotOptions.series.pointWidth = 22;
      this.updateValue = true;
    } else {
      this.highChartsOptions.plotOptions.series.pointWidth = 35;
      this.updateValue = true;
    }
    const topValueAdd = document.getElementById('newsrve');
    if (this.residentialService.service !== 'Switching Providers') {
      if (topValueAdd !== null) {
        topValueAdd.classList.add('newServiceTop');
      }
    } else if (topValueAdd && topValueAdd.classList.contains('newServiceTop')) {
      topValueAdd.classList.remove('newServiceTop');
    }
    this.bodyTagScroll = document.getElementsByTagName('body');
    this.bodyTagScroll[0].classList.add('singleScroll');
    this.discount = Math.round(this.discount);
    this.recommendProduct.new_tier.discount_percent = Math.round(
      this.recommendProduct.new_tier.discount_percent
    );
  }
  ngAfterViewInit() {
    const avgRecentBillElements =
      document.getElementsByClassName('avgrecentbill');
    for (let i = 0; i < avgRecentBillElements.length; i++) {
      if (avgRecentBillElements[i].classList.contains('avgrecentbill')) {
        if (
          this.averagePrice.length >= 12 ||
          this.avgbill.length >= 12 ||
          this.avgMthlyUsage.toString().length >= 12
        ) {
          avgRecentBillElements[i].classList.add('avgpricelen32');
        } else if (
          this.averagePrice.length === 11 ||
          this.avgbill.length === 11 ||
          this.avgMthlyUsage.toString().length === 11
        ) {
          avgRecentBillElements[i].classList.add('avgpricelen34');
        } else if (
          this.averagePrice.length === 10 ||
          this.avgbill.length === 10 ||
          this.avgMthlyUsage.toString().length === 10
        ) {
          avgRecentBillElements[i].classList.add('avgpricelen37');
        } else if (
          this.averagePrice.length === 9 ||
          this.avgbill.length === 9 ||
          this.avgMthlyUsage.toString().length === 9
        ) {
          avgRecentBillElements[i].classList.add('avgpricelen42');
        } else if (
          this.averagePrice.length === 8 ||
          this.avgbill.length === 8 ||
          this.avgMthlyUsage.toString().length === 8
        ) {
          avgRecentBillElements[i].classList.add('avgpricelen46');
        } else if (
          this.averagePrice.length === 7 ||
          this.avgbill.length === 7 ||
          this.avgMthlyUsage.toString().length === 7
        ) {
          avgRecentBillElements[i].classList.add('avgpricelen52');
        } else if (
          this.averagePrice.length <= 6 ||
          this.avgbill.length <= 6 ||
          this.avgMthlyUsage.toString().length <= 6
        ) {
          avgRecentBillElements[i].classList.add('avgpricelen58');
        }
      }
    }
  }

  back() {
    this.router.navigate([
      'recommendation',
      this.recommendationService.hg_accountId,
    ]);
  }

  showText() {
    this.fullText = true;
    this.partialText = false;
  }
  see() {
    this.partialText = true;
    this.fullText = false;
    this.showDetal = !this.showDetal;
    const arrowcollapse = document.getElementById('ordernowarrow');
    if (this.showDetal === false) {
      arrowcollapse.classList.remove('collapsed');
    } else {
      arrowcollapse.classList.add('collapsed');
    }
    const avgElements = document.getElementsByClassName('avgvalue');
    for (let i = 0; i < avgElements.length; i++) {
      if (avgElements[i].classList.contains('avgvalue')) {
        if (
          this.averagePrice.length >= 12 ||
          this.avgbill.length >= 12 ||
          this.avgMthlyUsage.toString().length >= 12
        ) {
          avgElements[i].classList.add('avgpricelen32');
        } else if (
          this.averagePrice.length === 11 ||
          this.avgbill.length === 11 ||
          this.avgMthlyUsage.toString().length === 11
        ) {
          avgElements[i].classList.add('avgpricelen34');
        } else if (
          this.averagePrice.length === 10 ||
          this.avgbill.length === 10 ||
          this.avgMthlyUsage.toString().length === 10
        ) {
          avgElements[i].classList.add('avgpricelen37');
        } else if (
          this.averagePrice.length === 9 ||
          this.avgbill.length === 9 ||
          this.avgMthlyUsage.toString().length === 9
        ) {
          avgElements[i].classList.add('avgpricelen42');
        } else if (
          this.averagePrice.length === 8 ||
          this.avgbill.length === 8 ||
          this.avgMthlyUsage.toString().length === 8
        ) {
          avgElements[i].classList.add('avgpricelen46');
        } else if (
          this.averagePrice.length === 7 ||
          this.avgbill.length === 7 ||
          this.avgMthlyUsage.toString().length === 7
        ) {
          avgElements[i].classList.add('avgpricelen52');
        } else if (
          this.averagePrice.length <= 6 ||
          this.avgbill.length <= 6 ||
          this.avgMthlyUsage.toString().length <= 6
        ) {
          avgElements[i].classList.add('avgpricelen58');
        }
      }
    }
  }
  showDetail() {
    if (this.showDetal === false) {
      this.showDetal = !this.showDetal;
      const arrowcollapse = document.getElementById('ordernowarrow');
      arrowcollapse.classList.add('collapsed');
    } else {
      this.showDetal = !this.showDetal;
    }
  }

  signmeup() {
    const accountId = this.recommendationService.hg_accountId;
    this.submitOrderProductDetails();
  }
  submitOrderProductDetails() {
    const energyProviderName =
        this.recommendationService.signupProduct.energy_provider,
      utilityName = this.recommendationService.signupProduct.utility_name,
      planName = this.recommendationService.signupProduct.product_key,
      productID = this.recommendationService.signupProduct.ProductID;

    this.residentialService
      .getEnergyProvidersPlanStatus(energyProviderName, utilityName, planName)
      .subscribe(
        (res: any) => {
          if (
            res &&
            productID !== res[0].ProductID &&
            this.residentialService.validateCreatedDateTime(res[0].createdDate)
          ) {
            this.assignModifiedEnergyProviderRates();
          } else {
            this.URLNavigate();
          }
        },
        (err) => {
          this.URLNavigate();
        }
      );
  }

  URLNavigate() {
    this.router.navigate([
      'energyplan-confirmation',
      this.recommendationService.hg_accountId,
    ]);
  }

  openNewEnergyRatesModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

  newEnergyProviderRates() {
    sessionStorage.setItem(
      'currentUser',
      this.recommendationService.hg_accountId
    );
    this.modalRef.hide();
    this.router.navigate([
      'recommendation/single-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  clickToggle() {
    $('#panel').slideToggle('slow');
    $('#flip').toggleClass('arrow');
  }
  loadScript() {
    let node = document.createElement('script'); // creates the script tag
    node.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10999221905'; // sets the source (insert url in between quotes)
    // node.type = 'text/javascript'; // set the script type
    node.async = true; // makes script run asynchronously
    // node.charset = 'utf-8';
    // append to head of document
    
    document.getElementsByTagName('head')[0].appendChild(node); 
  
    let script = this._renderer2.createElement('script');
    script.setAttribute('id', 'ChatScript');
    script.text = `
        (function(d, w, c) {
          w.BrevoConversationsID = '649dacacdbc74231a94a3297';
          w[c] = w[c] || function() {
              (w[c].q = w[c].q || []).push(arguments);
          };
          var s = d.createElement('script');
          s.async = true;
          s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
          if (d.head) d.head.appendChild(s);
      })(document, window, 'BrevoConversations');
    `;
  
    const existingScript = document.getElementById("ChatScript");
    if (!existingScript) {
      
    document.getElementsByTagName('head')[0].appendChild(script); 
    }
  }
}
